import React from 'react';
import { SkeletonItem } from '@atlaskit/side-navigation';
import { useIntl } from '@atlassian/jira-intl';
import { MenuItem } from '@atlassian/jira-navigation-apps-sidebar-common/src/common/ui/menu-item/main.tsx';
import { useBoard as useBoardDI } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/board/index.tsx';
import { useProject as useProjectDI } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/project/index.tsx';
import { withThrowOnError } from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/throw-when-no-data-and-error/index.tsx';
import { useDevOpsReportPreconditionResource as useDevOpsReportPreconditionResourceDI } from '@atlassian/jira-router-resources-devops-report-group/src/services/index.tsx';
import { isDevopsFeatureDisabledInFedRamp } from '@atlassian/jira-software-devops-fedramp-utils/src/index.tsx';
import { messages } from './messages.tsx';

export const useBoard = withThrowOnError(useBoardDI);
export const useProject = withThrowOnError(useProjectDI);
export const useDevOpsReportPreconditionResource = withThrowOnError(
	useDevOpsReportPreconditionResourceDI,
);

export const DevOpsReports = () => {
	const { formatMessage } = useIntl();
	const { data: board } = useBoard();
	const { data: project } = useProject();
	const {
		data: devOpsReportReportGroupPrecondition,
		loading: devOpsReportReportGroupPreconditionLoading,
	} = useDevOpsReportPreconditionResource();

	if (isDevopsFeatureDisabledInFedRamp()) {
		return null;
	}

	if (devOpsReportReportGroupPreconditionLoading || board == null || project == null)
		return <SkeletonItem />;

	return (
		<>
			{devOpsReportReportGroupPrecondition !== null &&
				devOpsReportReportGroupPrecondition.hasViewDevToolsPermission &&
				devOpsReportReportGroupPrecondition.hasViewAggregateDataPermission && (
					<MenuItem
						analytics={{ itemId: 'cycleTimeReport' }}
						selectedOn={['software-reports-cycle-time']}
						href={`/jira/software/projects/${project.key}/boards/${board.id}/reports/cycle-time`}
					>
						{formatMessage(messages.itemCycleTime)}
					</MenuItem>
				)}
			{devOpsReportReportGroupPrecondition !== null &&
				devOpsReportReportGroupPrecondition.hasViewDevToolsPermission &&
				devOpsReportReportGroupPrecondition.hasViewAggregateDataPermission && (
					<MenuItem
						analytics={{ itemId: 'deploymentFrequencyReport' }}
						selectedOn={['software-reports-deployment-frequency']}
						href={`/jira/software/projects/${project.key}/boards/${board.id}/reports/deployment-frequency`}
					>
						{formatMessage(messages.itemDeploymentFrequency)}
					</MenuItem>
				)}
		</>
	);
};
